import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
// import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
import axios from "axios";

import SelectListComponent from "../SelectListComponent";
import { globalConfig } from "../../../config/config";
// import { useContentObjectContext } from "../contexts/ContentObjectContext";

// const querystring = require("querystring");

const CreateContentFacades = () => {
  const [contentFacadeIndexTypes, setContentFacadeIndexTypes] = useState([]);
	const token = globalConfig.hardcoded_header;
//   const { currentContentObject } = useContentObjectContext();
  const [entitlements, setEntitlements] = useState([]);
  const [message, setMessage] = useState("");
  useEffect(() => {
    handleOnLoad();
  }, []);
  const [state, setState] = useState({
    contentFacadeId: 0,
    contentId: 0, //currentContentObject,
    contentFacadeTypeId: 0,
    securityContextId: 0,
    serverModuleValueCode: 0,
    contentFacadeName: "",
    contentFacadeDescription: "",
    effectiveDate: new Date().toISOString(),
    expirationDate: new Date().toISOString(),
    lastUpdateUser: 0,
    lastUpdateDate: new Date().toISOString(),
  });

  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }

  function handleSubmit(event) {
    event.preventDefault();
    console.log("handling submit");

    var url = `${globalConfig.apiDatahubUrl}/content-facades`;
    var idUrl = `${globalConfig.apiMainUrl}/next-id-generator/get-next/content-facades/contentFacadeId`;

    axios.get(idUrl,  apiHeader(token)).then((response) => {
      state.contentFacadeId = response.data["nextId"];

      //console.log("new category id = " + JSON.stringifyt(this.state.contentCategoriesObject.contentCategoryId));

      console.log("request object = " + JSON.stringify(state));
      axios
        .post(url, state,  apiHeader(token))
        .then((response2) => {
          console.log("response.data");
          console.log(response2.status + ":" + response2.data.contentFacadeId);
          // && response2.data.contentFacadeId === this.state.contentFacadeId
          if (response2.status === 200) {
            setMessage("Success");
          } else {
            setMessage("Failed");
          }
          console.log(message);
          //
          event.preventDefault();
          //response.send(this.message);
        })
        .catch((err) => {
          console.log("error - " + err);
        });
      console.log("message info - " + message);
      setState({ ...state, contentFacadeId: 0, contentFacadeName: "" });
    });

    // console.log("SetState Message info-" + this.contentFacadeTypeId);
    // console.log("SetState Message info-" + this.contentFacadeName);
  }
  function handleRest(event) {
    setState({ ...state, contentFacadeId: 0, contentFacadeName: "" });
    // this.contentObjectName = "";
  }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-facade-types`,
         apiHeader(token)
      )
      .then((res) => {
        const contentFacadeIndexTypes = res.data;
        console.log(contentFacadeIndexTypes);
        setContentFacadeIndexTypes(contentFacadeIndexTypes);
      })
      .catch((x) => {
      });

    axios
      .get(
        `${globalConfig.systemCodesUrl}/ENTITLEMENTS`,
         apiHeader(token)
      )
      .then((res) => {
        const entitlements = res.data;
        console.log("results", entitlements);
        setEntitlements(entitlements);
      })
      .catch((err) => {
        console.log("here");
        console.log(err);
      });
  };

  return (
    <form>
		<div style={{display:"flex",justifyContent:"space-between"}}>
	        <h4>Create Content Facade</h4>			
			<Link to="/breeze/list-content-facades">
				<Button variant="contained">
					Go Back
				</Button>
			</Link>
		</div>
		<hr/>

      <div className="container-fluid"> 
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Content Object Name">
            Content Object Name
          </label>
          <input
            readOnly={true}
            id="contentId"
            className="form-control input-xlarge col-sm-8"
            value={state.contentId}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Facade Type">
            Facade Type
          </label>
          <select
            id="contentFacadeTypeId"
            className="form-control input-xlarge col-sm-8"
            value={state.contentFacadeTypeId}
            onChange={handleChange}
          >
            {/* <option value="#{contentFacadeForm.contentFacadeTypeSelectList}" /> */}
            <option>Select Facade Type</option>
            {contentFacadeIndexTypes.map(
              ({ contentFacadeTypeDescr, contentFacadeTypeId }) => (
                <option key={contentFacadeTypeId} value={contentFacadeTypeId}>
                  {contentFacadeTypeDescr}
                </option>
              )
            )}
          </select>
          {/* <SelectListComponent entityName ={"system-code-values"} valueFilterColumnName = {"systemCodeId"} valueFilter = {"235"} displayColumnName ={"systemCodeValueValue"} keyColumnName ={"systemCodeValueId"}
				IdName={"contentFacadeTypeId"}
				TypeId={state.contentFacadeTypeId}
				handle={handleDropDown}
				/>	 */}
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Facade Object">
            Facade Object
          </label>
          <input
            id="contentFacadeName"
            className="form-control input-xlarge col-sm-8"
            value={state.contentFacadeName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Description">
            Description
          </label>
          <textarea
            id="contentFacadeDescription"
            className="form-control input-xlarge col-sm-8"
            cols="60"
            rows="5"
            value={state.contentFacadeDescription}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Server Module">
            Server Module
          </label>
          <select
            id="serverModuleValueCode"
            className="form-control input-xlarge col-sm-8"
            value={state.serverModuleValueCode}
            onChange={handleChange}
          >
            <option value={0}>Select Entitlement </option>
            {entitlements.map(
              ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                <option key={systemCodeValueId} value={systemCodeValueId}>
                  {systemCodeValueValue}{" "}
                </option>
              )
            )}
          </select>
          {/* <SelectListComponent
            entityName={"system-code-values"}
            valueFilterColumnName={"systemCodeId"}
            valueFilter={"222"}
            displayColumnName={"systemCodeValueValue"}
            keyColumnName={"systemCodeValueId"}
            IdName={"serverModuleValueCode"}
            TypeId={state.serverModuleValueCode}
            handle={handleDropDown}
          /> */}
        </div>

        <hr />
        <div columns="3">
          <button
            className="btn btn-primary"
            value="Clear"
            onClick={handleRest}
          >
            Clear
          </button>
          &nbsp;
          <button
            className="btn btn-success"
            value="Create"
            onClick={handleSubmit}
          >
            Create
          </button>
        </div>
      </div>
    </form>
  );
};

export default CreateContentFacades;
